export default __webpack_public_path__ + "static/media/RamBG.321acb7c.png";